
import { format as format_1 } from "../fable_modules/fable-library-js.5.0.0/String.js";
import { some } from "../fable_modules/fable-library-js.5.0.0/Option.js";
import { DateTimeOffset_dateTimeStr, DateTimeOffset_timeStr, cn as cn_2, DateTimeOffset_adjustFromContext } from "../Components/TimeZones/Components.js";
import { TextModule_View } from "../Components/StenaWebUI/Core/Text.js";
import { ofList } from "../fable_modules/fable-library-js.5.0.0/Map.js";
import { singleton, ofArray, map } from "../fable_modules/fable-library-js.5.0.0/List.js";
import { WhiteSpaceType, UserSelectType, TextSize, TextVariant } from "../Components/StenaWebUI/Core/Text.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { useContext, createElement } from "react";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { timeZoneContext } from "../Components/TimeZones/Context.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { ChipModule_View } from "../Components/StenaWebUI/Elements/Chip.js";

export function formatNumber(format, x) {
    return format_1('{0:' + format + '}', x);
}

export function fromTryMethod(f, x) {
    const patternInput = f(x);
    if (patternInput[0]) {
        return some(patternInput[1]);
    }
    else {
        return undefined;
    }
}

export function rotateDirection180(x) {
    return x + ((x < 180) ? 180 : -180);
}

export function timeInContext(ctx, strF, time) {
    return strF(DateTimeOffset_adjustFromContext(ctx, time));
}

export function DivsForStandardTable_defaultDiv(value) {
    const children = singleton(TextModule_View(ofList(map((value_2) => value_2, ofArray([["variant", new TextVariant(0, [])], ["size", new TextSize(1, [])], ["userSelect", new UserSelectType(6, [])], ["whiteSpace", new WhiteSpaceType(4, [])], ["children", value]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })));
    return createElement("div", defaultOf(), ...children);
}

function DivsForStandardTable_timeChip(strF, time) {
    let p_1_1;
    const ctx = useContext(timeZoneContext);
    return HtmlHelper_createElement("div", ofArray([["className", cn_2.className("timeCell")], ["children", singleton((p_1_1 = ofList(map((value_4) => value_4, ofArray([["label", timeInContext(ctx, strF, time)], ["variant", "secondary"]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(ChipModule_View, {
        p: p_1_1,
    })))]]));
}

export function DivsForStandardTable_timeDiv(time) {
    return DivsForStandardTable_timeChip(DateTimeOffset_timeStr, time);
}

export function DivsForStandardTable_dateTimeDiv(time) {
    return DivsForStandardTable_timeChip(DateTimeOffset_dateTimeStr, time);
}

